import { useSuspenseQuery } from "@tanstack/react-query";
import { todayQuickActionsEncountersQueryOptions } from "../api/queries";
import ConsultationsCard from "./cards/consultations-card";
import NoPreviewCard from "./cards/no-preview-card";
import { QuickActionCardSkeleton } from "./cards/quick-action-card-skeleton";
import { useParams } from "@tanstack/react-router";
import { getApiProgram } from "~/lib/utils";

const Consultations = () => {
  const {program} = useParams({strict: false})
  const apiProgram = getApiProgram(program ?? "")
  const { data, isLoading } = useSuspenseQuery(todayQuickActionsEncountersQueryOptions({
    limit: 1,
    skip: 0,
    type: "consultation",
    // date_filter: "today",
    program: apiProgram,
    type_sort_order: "consultation",
    status: "unresolved",
    sort: "new_old"
  }));
  // console.log("consultation_data", data)

  return (
    <div className="flex flex-col gap-4">
      {isLoading ? (<QuickActionCardSkeleton />) :!isLoading && data ? (
        <div>
          {data && (
            <ConsultationsCard 
              item={data}
              program={program ?? ""}
            />
          )}
        </div>
      ) : (
        <NoPreviewCard
          icon={program === "urgent-care" ? "/assets/monitor.png" : "/assets/notifications.svg"}
          title="Nothing to Display"
          description="You have no encounters to see today, when you do, they will appear here"
          className="w-full h-[440px]"
        />
      )}
    </div>
  );
};

export default Consultations;

